module.exports = __webpack_public_path__ + "img/12-doc-documentos-lista.d6d8ae31.png";